<script lang="ts">
    import { previewEntryMap } from "./preview"
    import Content from "./Content.svelte"
    import { spaNavigate } from "../../functionTools/navigation"

    let previewContent: ContentEntry = $derived($previewEntryMap["content"] as ContentEntry)

    $effect(() => {
        if (previewContent && previewContent?.generalDetails?.path)
            spaNavigate(`${previewContent?.generalDetails?.path || ""}`)
    })
</script>

{#if previewContent}
    <Content {previewContent} />
{/if}
